import React, { useEffect } from 'react';

const GIAdsInitialConfig = {
  userCallbackForView: function (err, id) {},
  userClickHandlerForClick: function (err, id) {},
  onError: function () {
    console.log('On Error Callback');
  },
  ORG: 'GI',
  AUTH_COOKIE_KEY: 'OAUTH-GOIBIBO'
};

const MMTAd = props => {
  const { id, lob, pageName, section, cid } = props;
  useEffect(() => {
    if (window && window.GIAdsOnloadFunc) {
      window.GIAdsOnloadFunc();
    } else {
      window.AdMMTSDK = [];
      window.AdMMTSDK.push(GIAdsInitialConfig);
    }
  }, []);

  return (
    <>
      {cid ? (
        <mmtad data-cid={cid} loading="lazy" />
      ) : (
        <mmtad
          data-id={id}
          data-lob={lob}
          data-pageName={pageName}
          data-section={section}
          loading="lazy"
        ></mmtad>
      )}
    </>
  );
};

export default MMTAd;
